import { useEffect, useMemo } from 'react';
import type { Observable } from 'rxjs';
import { Subject } from 'rxjs';

const useUnmount = (): Observable<void> => {
  const unmountObservable = useMemo(() => new Subject<void>(), []);

  useEffect(
    () => () => {
      unmountObservable.next();
      unmountObservable.complete();
    },
    [unmountObservable]
  );

  return unmountObservable;
};

export default useUnmount;
